import React from 'react';
import './SpaceBackground.css';

function SpaceBackground() {
  return <div className="rain-container"></div>;
}

export default SpaceBackground;
